(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/models/play.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/models/play.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.models.Play = Backbone.Model.extend({
    defaults: function() {
      return {
        gameId: undefined,
        gameName: undefined,
        activeGames: undefined
      };
    },

    parse: function(data) {
      data.activeGames = new svs.bingo.collections.ActiveGames(
        data.activeGames
      );
      return data;
    },

    bingoClientCallback: function(call, obj) {
      var stat = {},
        event = (obj && obj.event) || call;

      switch (event) {
        case 'register':
          location.href = svs.core.urlMapping.get('customerRegistrationHome');
          break;

        case 'login':
          svs.components.customer_login.login();
          break;

        case 'deposit':
          svs.utils.form.postToUrl(
            svs.core.urlMapping.get('transactionsHome'),
            'returnUrl: ' + window.location
          );
          break;

        case 'BALANCE_UPDATE':
          svs.components.account_balance.set(obj.balance.amount);
          break;

        case 'BINGO_GAME_ON_WAGER':
          stat = {
            gameId: this.get('gameId'),
            gameName: this.get('gameName'),
            betAmount: obj.betTotal,
            wagerId: obj.wagerid
          };
          svs.components.account_balance.set(obj.balance.amount);
          svs.bingo.nyxChannel.request('sendStatistics', stat);
          break;
        default:
      }
    }
  });
})(Backbone, _, svs);


 })(window);